import React, { useEffect } from 'react';
import './Quotation.css';
import {useParams} from "react-router-dom";
import Header from "../Clientes/components/Header/Header";
import Footer from "../Clientes/components/Footer/Footer";
import Formularios from "../Formularios";
import { trackPageView } from "../../utils/analytics/analytics";
import { ANALYTICS_SECTIONS } from "../../constants/analyticsConstants";
import { getQuotationModule } from "../../utils/analytics/analyticsHelpers";

const productoMap = {
    automotor: 'para tu vehiculo',
    asistenciaviajero: 'para tu viaje',
    motovehículo: 'para tu motovehículo',
    bicicleta: 'para tu bicicleta u otros',
    monopatin: 'para tu monopatín u otros',
    notebook: 'para tu notebook u otros',
    hogar: "para tu hogar",
    tablet: 'para tu tablet u otros',
    robosvarios: 'contra robos'
};

function Quotation() {
    const params = useParams();
    const productoMaped = productoMap[params['producto']] || params['producto'];

    return (
        <main className="quotation__container">
            <Header sticky={false}/>
            <div className="quotation__banner">
                <h1>Cotizá el seguro {productoMaped}</h1>
                <h2>
                    Explorá las opciones disponibles en diferentes aseguradoras y dejá que un
                    productor experto te asesore.</h2>
            </div>
            <Formularios/>
            <Footer/>
        </main>
    );
}

export default Quotation;
